import React from 'react';
import PropTypes from 'prop-types';
import { Panel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export default function PanelHeader({ icon, title, subtitle, infoLink, tooltipLink }) {
  return (
    <Panel.Heading className="row-eq-height align-items-center p-4">
      <FontAwesomeIcon className="text-primary" icon={icon} size="2x" />
      <div className="flex-grow ml-3">
        <Panel.Title className="my-0">
          {title}
          {infoLink && (
            <OverlayTrigger
              overlay={<Tooltip id="info-link-tooltip">{tooltipLink || 'View more information'}</Tooltip>}
              placement="top"
            >
              <a
                className="ml-2"
                href={infoLink}
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon className="text-primary" icon={faInfoCircle} size="sm" />
              </a>
            </OverlayTrigger>
          )}
        </Panel.Title>
        <small className="mx-2">{subtitle}</small>
      </div>
    </Panel.Heading>
  );
}

PanelHeader.propTypes = {
  icon: PropTypes.object.isRequired,
  infoLink: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tooltipLink: PropTypes.string
};
